import { connect } from 'react-redux';
import { fetchReviews, clearReviews } from 'marketing/ducks';
import Reviews from 'landing_pages/components/reviews';

const mapStateToProps = ({ marketing }) => {
  return {
    items: marketing.reviews,
    fetching: marketing.fetchingReviews,
  };
}

export default connect(mapStateToProps, {
  fetch: fetchReviews,
  clear: clearReviews
})(Reviews);



// WEBPACK FOOTER //
// ./landing_pages/containers/reviews.js